import PropTypes from "prop-types";
import {useMemo, useState} from "react";
import Input from "@/components/Input/Input";

const CurrencySymbolIcon = ({symbol = '', parentClassNames = '', classNames = ''}) => {
  return <div className={classNames}>
    {symbol}
  </div>;
};

const PlatformFeeChooser = ({
  platformFee,
  formik,
  saveError = null,
  fieldName,
  label,
  onChange,
}) => {
  const disableOptionId = `${platformFee.currency_code}-disable`;
  const enableOptionId = `${platformFee.currency_code}-enable`;
  const [feeData, setFeeData] = useState({...platformFee});
  const onEnableChange = (e) => {
    let newState = { ...feeData, enabled: e.target.value === "1" };
    setFeeData(newState);
    onChange(newState);
  };
  const onAmountChange = (e) => {
    let newFeeData = { ...feeData, amount: Number(e.target.value) };
    setFeeData(newFeeData);
    onChange(newFeeData);
  };

  const leftIcon = useMemo(() => {
    if (feeData.amount_type === "fixed") {
      return <CurrencySymbolIcon className="text-[14px]" parentClassNames="py-1 px-2" symbol={feeData.currency_code} />;
    }
  }, [feeData]);
  const rightIcon = useMemo(() => {
    if (feeData.amount_type !== "fixed") {
      return <CurrencySymbolIcon className="text-[14px]" parentClassNames="py-1 px-2" symbol="%" />;
    }
  }, [feeData]);

  return (
    <div className="flex flex-row justify-between">
      <label>{label}</label>
      <div className="flex flex-col w-[450px]">
        <div className="flex flex-row gap-3">
          <label
            key={disableOptionId}
            htmlFor={disableOptionId}
            className="flex items-center gap-1 cursor-pointer pb-1 rounded-md focus:ring-2 focus:ring-blue-500"
          >
            <input
              id={disableOptionId}
              type="radio"
              value={0}
              checked={!feeData.enabled}
              onChange={onEnableChange}
            />
            <span>Default</span>
          </label>
        </div>
        <div className="flex flex-row gap-3">
          <label
            key={enableOptionId}
            htmlFor={enableOptionId}
            className="flex items-center gap-1 cursor-pointer rounded-md focus:ring-2 focus:ring-blue-500"
          >
            <input
              id={enableOptionId}
              type="radio"
              value={1}
              checked={feeData.enabled}
              onChange={onEnableChange}
            />
            <span>Custom: </span>
            <Input
              id={`${enableOptionId}-amount`}
              type="number"
              step={0.01}
              min={0}
              disabled={!feeData.enabled}
              value={feeData.amount}
              onChange={onAmountChange}
              leftIcon={leftIcon}
              rightIcon={rightIcon}
            />
          </label>
        </div>
        {((formik.touched[fieldName] && formik.errors[fieldName]) ||
          saveError?.status === 422) && (
          <div className="text-destructive w-[450px]">
          {formik?.errors[fieldName] ??
              saveError?.response?.data?.errors[fieldName]?.join(" ")}
          </div>
        )}
      </div>
    </div>
  );
};

PlatformFeeChooser.propTypes = {
  platformFee: PropTypes.shape({
    enabled: PropTypes.bool,
    currency_code: PropTypes.string,
    amount_type: PropTypes.string,
    amount: PropTypes.number,
  }).isRequired,
  formik: PropTypes.shape({
    values: PropTypes.object.isRequired,
    touched: PropTypes.object,
    errors: PropTypes.object,
    setFieldValue: PropTypes.func.isRequired,
  }).isRequired,
  saveError: PropTypes.shape({
    status: PropTypes.number,
    response: PropTypes.shape({
      data: PropTypes.shape({
        errors: PropTypes.object,
      }),
    }),
  }),
  fieldName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PlatformFeeChooser;
